import c1 from '../assets/png/certificates/c1.png'
import c2 from '../assets/png/certificates/c2.png'
import c3 from '../assets/png/certificates/c3.png'
import c4 from '../assets/png/certificates/c4.png'
import c5 from '../assets/png/certificates/c5.png'
import c6 from '../assets/png/certificates/c6.png'
import c7 from '../assets/png/certificates/c7.png'
import c8 from '../assets/png/certificates/c8.png'
import c9 from '../assets/png/certificates/c9.png'
import c10 from '../assets/png/certificates/c10.png'

export const blogData = [
    {
        id: 1,
        title: 'Java Training, IIT Bombay',
        description: 'Java training certification by Spoken Tutorial',
        date: 'Jan 03, 2022',
        image: c1,
        url: 'https://drive.google.com/file/d/1m5YfdDT0FU5Ldo8QRq0BF9wwGwiwoJPe/view?usp=sharing'
    },
    {
        id: 2,
        title: 'Network Security Specialist',
        description: 'ICSI | CNSS Certified Network Security Specialist',
        date: 'May 29, 2020',
        image: c2,
        url: 'https://drive.google.com/file/d/1IdLaEkEOLNcaSH4xnEsyYULsDICLSpjN/view?usp=sharing'
    },
    {
        id: 3,
        title: 'Python Training, IIT Bombay',
        description: 'Python training certification by Spoken Tutorial',
        date: 'Jan 29, 2021',
        image: c3,
        url: 'https://drive.google.com/file/d/1NjKWcVJMHQMU_2Kl5bZT0ZwDFWgTQQur/view?usp=sharing'
    },
    {
        id: 4,
        title: 'App-Dev and its various opportunities',
        description: 'App-Dev and its various opportunities program certfication by DSC',
        date: 'Oct 13, 2020',
        image: c4,
        url: 'https://drive.google.com/file/d/13GiMeke6D5plXuFTT7Ljlp-Y3FlSFQOJ/view?usp=sharing'
    },
    {
        id: 5,
        title: 'UI/UX',
        description: 'UI/UX course certification by DSC',
        date: 'Oct 15, 2020',
        image: c5,
        url: 'https://drive.google.com/file/d/13G3LDqAuA-jWDfYHoKjWzYAWSEjO1bGl/view?usp=sharing'
    },
    {
        id: 6,
        title: 'Vue Js and Firebase',
        description: 'Vue Js and Firebase - build an iOS and Android chat app certification by Udemy',
        date: 'May 30, 2021',
        image: c6,
        url: 'https://drive.google.com/file/d/1_wDRIAe4-8nVBwrhISUOCWjn_Fj15msN/view?usp=sharing'
    },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/